import { createContext, FC, PropsWithChildren, useContext, useEffect, useState } from "react";

import "../utils/scrambler";
import { formatWallClockDate, parseWallClockDate } from "@asd/customer-portal-ui";
import { Moment } from "moment-timezone";

declare global {
  interface Window {
    CP_SCRAMBLE_PII?: boolean;
  }
}

type ScramblerContextType = {
  isScramblerEnabled: boolean;
};

const ScramblerContext = createContext<ScramblerContextType>({} as ScramblerContextType);

export const useScrambler = () => useContext(ScramblerContext);

export const SCRAMBLED_PROVIDER_NAMES = [
  "Donald Duck",
  "Goofy",
  "Pluto",
  "Minnie Mouse",
  "Daisy Duck",
  "Scrooge McDuck",
  "Huey Duck",
  "Dewey Duck",
  "Louie Duck",
  "Chip",
  "Dale",
  "Clarice",
  "Max Goof",
  "Pete",
  "Morty Fieldmouse",
  "Ferdie Fieldmouse",
  "Gadget Hackwrench",
  "Zipper",
  "Launchpad McQuack",
  "Darkwing Duck",
  "Sheriff of Nottingham",
  "Robin Hood",
  "Little John",
  "Friar Tuck",
  "Maid Marian",
  "Prince John",
  "Sir Hiss",
];

export const getScrambledDate = (originalDate: Moment): Moment => originalDate.subtract(5, "months");

export const getScrambledDateString = <T extends string | null | undefined>(dateString: T): T =>
  (dateString ? formatWallClockDate(getScrambledDate(parseWallClockDate(dateString))) : dateString) as T;

export const getScrambledName = () => SCRAMBLED_PROVIDER_NAMES[Math.floor(Math.random() * SCRAMBLED_PROVIDER_NAMES.length)];

const ScramblerProvider: FC<PropsWithChildren> = ({ children }) => {
  const [isScramblerEnabled, setIsScramblerEnabled] = useState<boolean>(false);

  useEffect(() => {
    const checkScramblerSetting = () => {
      setIsScramblerEnabled(!!window.CP_SCRAMBLE_PII);
    };

    checkScramblerSetting();

    const handleScramblerChange = () => {
      checkScramblerSetting();
    };

    window.addEventListener("cpScramblePIIChange", handleScramblerChange);

    return () => {
      window.removeEventListener("cpScramblePIIChange", handleScramblerChange);
    };
  }, []);

  return <ScramblerContext.Provider value={{ isScramblerEnabled }}>{children}</ScramblerContext.Provider>;
};

export default ScramblerProvider;
